import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { AccordionModule } from 'ngx-bootstrap/accordion';
import { MenuComponent } from "../menu/menu.component";

@Component({
  selector: 'app-side-bar',
  standalone: true,
  imports: [CommonModule, AccordionModule, MenuComponent],
  templateUrl: './side-bar.component.html',
  styleUrls: ['./side-bar.component.css']
})
export class SideBarComponent {
  @Input() itemList: any[] | undefined;
  @Output() itemSelected = new EventEmitter<any>();
  activeItem: any = null;
  selectedItem: any;

  isOpen(item: any) {
    return this.activeItem === item;
  }

  toggle(item: any) {
    if (this.activeItem === item) {
      this.activeItem = null;
    } else {
      this.activeItem = item;
    }
  }

  onItemSelected(item: any): void {
    
    this.itemSelected.emit(item);
    this.selectedItem = item;
  }

  onSelect(item: any) {
    this.selectedItem = item;
  }
}
